import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Smartphone, X } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

/** Shown once to a Business/Enterprise operator: your own app is included, here is how to get it. */
export const StoreAppNudge = () => {
  const [state, setState] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    api.get("/company/app-request").then(({ data }) => setState(data)).catch(() => {});
  }, []);

  const dismiss = () => {
    setHidden(true);
    api.post("/company/dismiss-hint", { hint: "store_app" }).catch(() => {});
  };

  if (!state || hidden || !state.white_label || state.hint_dismissed || state.request) return null;

  return (
    <div data-testid="store-app-nudge"
      className="relative overflow-hidden rounded-xl border border-gold/30 bg-gradient-to-r from-ink-800 to-ink-900 p-6">
      <button data-testid="store-app-nudge-dismiss" onClick={dismiss}
        className="absolute right-3 top-3 text-slate-500 transition-colors hover:text-slate-200">
        <X className="h-4 w-4" />
      </button>
      <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-gold">
        <Smartphone className="h-3.5 w-3.5" /> Included in your plan
      </p>
      <p className="mt-3 font-display text-xl text-slate-50">
        Your own app on Google Play and the App Store
      </p>
      <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-400">
        Your passengers install <span className="text-slate-200">{state.app_name}</span> — your name,
        your icon, your colours — and book from their home screen. Design it in a couple of minutes,
        then ask us to publish it for you.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Button asChild className="bg-gold text-ink-900 hover:bg-gold-light">
          <Link to="/app/settings?tab=myapp" data-testid="store-app-nudge-design">Design my app</Link>
        </Button>
        <Button asChild variant="outline">
          <Link to="/app/settings?tab=myapp" data-testid="store-app-nudge-request">
            Have it published
          </Link>
        </Button>
      </div>
    </div>
  );
};
